module.exports = __webpack_public_path__ + "img/takeaway.fb1ef92c.png";